import { Injectable } from '@angular/core';
import { UserSessionService } from './user-session.service';
import { AppInsightsLoggerService } from './app-insights-logger.service';
import { ApplicationService } from './application.service';
import { PartialSaveResp } from '../model/partial-save-resp';

@Injectable({
  providedIn: 'root'
})
export class PartialSaveService {

  constructor(
    private userSessionService: UserSessionService,
    private appInsightsLoggerService: AppInsightsLoggerService,
    private applicationService: ApplicationService
  ) { }

  updateAcknowledgements(){
    this.applicationService.updateAcknowledgementsWithExStreamCloudApplication(this.userSessionService.data.mhsId, this.userSessionService.data.mhsApplication.agreedOrAcknowledged)
    .subscribe( response => {
      let resp = new PartialSaveResp();
      resp.httpStatusCode = response.httpStatusCode;
      resp.message = response.message;
      resp.data = response.data;
      if(resp.httpStatusCode === 201){
        this.appInsightsLoggerService.log('info', 'Acknowledgements updated successfully. MhsId: ' + this.userSessionService.data.mhsId, '');
      } else {
        this.appInsightsLoggerService.log('error', 'Acknowledgements update failed. MhsId: ' + this.userSessionService.data.mhsId, '');
      }
    });
  }

  updateElectronicCommunication(){
    this.applicationService.updateElectronicCommunicationWithExStreamCloudApplication(this.userSessionService.data.mhsId, this.userSessionService.data.mhsApplication.electronicCommunication)
    .subscribe( response => {
      let resp = new PartialSaveResp();
      resp.httpStatusCode = response.httpStatusCode;
      resp.message = response.message;
      resp.data = response.data;
      if(resp.httpStatusCode === 201){
        this.appInsightsLoggerService.log('info', 'Electronic communication updated successfully. MhsId: ' + this.userSessionService.data.mhsId, '');
      } else {
        this.appInsightsLoggerService.log('error', 'Electronic communication update failed. MhsId: ' + this.userSessionService.data.mhsId, '');
      }
    });
  }

  updateEconsent(){
    this.applicationService.updateEconsentWithExStreamCloudApplication(this.userSessionService.data.mhsId, this.userSessionService.data.mhsApplication.econsent)
    .subscribe( response => {
      let resp = new PartialSaveResp();
      resp.httpStatusCode = response.httpStatusCode;
      resp.message = response.message;
      resp.data = response.data;
      if(resp.httpStatusCode === 201){
        this.appInsightsLoggerService.log('info', 'E-consent updated successfully. MhsId: ' + this.userSessionService.data.mhsId, '');
      } else {
        this.appInsightsLoggerService.log('error', 'E-consent update failed. MhsId: ' + this.userSessionService.data.mhsId, '');
      }
    });
  }

  updateFlowStatusToReady(){
    this.applicationService.updateFlowStatusToReady(this.userSessionService.data.mhsId)
    .subscribe( response => {
      if(response === 201){
        this.appInsightsLoggerService.log('info', 'Flow status updated to ready successfully. MhsId: ' + this.userSessionService.data.mhsId, '');
      } else {
        this.appInsightsLoggerService.log('error', 'Flow status update to ready failed. MhsId: ' + this.userSessionService.data.mhsId, '');
      }
    });
  }
}